var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXpLevel2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2975",
    "data-name": "Group 2975",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.884,
    height: 54.637,
    viewBox: "0 0 37.884 54.637",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1306",
    "data-name": "Rectangle 1306",
    width: 37.884,
    height: 54.637,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32781",
    "data-name": "Path 32781",
    d: "M43.869,86.882v20.126l-9.493-4.177-9.493,4.177V86.882Z",
    transform: "translate(-15.434 -61.89)",
    fill: "#6498e2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32782",
    "data-name": "Path 32782",
    d: "M59.376,86.882H49.883v15.949l9.493,4.177Z",
    transform: "translate(-30.941 -61.89)",
    fill: "#aecef4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2974",
    "data-name": "Group 2974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2973",
    "data-name": "Group 2973",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32783",
    "data-name": "Path 32783",
    d: "M34.376,86.882H24.883v5.9a22.1,22.1,0,0,0,9.493,2.142Z",
    transform: "translate(-15.434 -55.89)",
    fill: "#4985ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32784",
    "data-name": "Path 32784",
    d: "M49.883,86.882v8.043a22.1,22.1,0,0,0,9.493-2.142v-5.9Z",
    transform: "translate(-30.941 -55.89)",
    fill: "#8fbae5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32785",
    "data-name": "Path 32785",
    d: "M41.388,106.046a1.517,1.517,0,0,1-.611-.129L31.9,102.009l-8.882,3.908a1.519,1.519,0,0,1-2.131-1.39V84.4A1.519,1.519,0,0,1,22.4,82.882H41.389A1.519,1.519,0,0,1,42.907,84.4v20.126a1.519,1.519,0,0,1-1.519,1.519M31.9,98.831a1.517,1.517,0,0,1,.612.129L39.87,102.2V85.92H23.921V102.2l7.363-3.239a1.517,1.517,0,0,1,.612-.129",
    transform: "translate(-12.953 -59.409)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32786",
    "data-name": "Path 32786",
    d: "M48.022,107.633a1.139,1.139,0,0,1-1.139-1.139V93.927a1.139,1.139,0,0,1,2.278,0v12.567a1.139,1.139,0,0,1-1.139,1.139",
    transform: "translate(-29.08 -65.553)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32787",
    "data-name": "Path 32787",
    d: "M33.735,33.734a17.432,17.432,0,1,1,0-24.653,17.432,17.432,0,0,1,0,24.653",
    transform: "translate(-2.467 -2.466)",
    fill: "#bcc5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32788",
    "data-name": "Path 32788",
    d: "M40,40a10.671,10.671,0,1,1,0-15.091A10.671,10.671,0,0,1,40,40",
    transform: "translate(-13.51 -13.51)",
    fill: "#bcc5ce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32789",
    "data-name": "Path 32789",
    d: "M9.185,9.081A17.358,17.358,0,0,0,4.143,19.969,29.227,29.227,0,0,0,10.4,22.851a11.2,11.2,0,1,1,22.222,0,29.244,29.244,0,0,0,6.258-2.883A17.428,17.428,0,0,0,9.185,9.081",
    transform: "translate(-2.57 -2.466)",
    fill: "#d3d9dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32790",
    "data-name": "Path 32790",
    d: "M18.941,37.883a18.942,18.942,0,1,1,13.4-5.541,18.892,18.892,0,0,1-13.4,5.541m0-34.848A15.906,15.906,0,1,0,30.194,7.689,15.864,15.864,0,0,0,18.941,3.036M31.268,31.268h0Z",
    transform: "translate(0 0)",
    fill: "#4a4e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32791",
    "data-name": "Path 32791",
    d: "M35.206,48.092a.411.411,0,0,1-.29-.116.389.389,0,0,1-.124-.3V36.9a.391.391,0,0,1,.124-.3.413.413,0,0,1,.29-.116H37a.55.55,0,0,1,.406.141.783.783,0,0,1,.174.224l2.918,5.239,2.918-5.239a1.66,1.66,0,0,1,.174-.224.517.517,0,0,1,.406-.141h1.774a.435.435,0,0,1,.307.116.391.391,0,0,1,.124.3V47.678a.389.389,0,0,1-.124.3.433.433,0,0,1-.307.116H43.794a.432.432,0,0,1-.307-.116.389.389,0,0,1-.124-.3V41.461l-1.874,3.465a.758.758,0,0,1-.2.265.535.535,0,0,1-.365.116h-.862a.533.533,0,0,1-.365-.116.974.974,0,0,1-.216-.265L37.61,41.461v6.217a.4.4,0,0,1-.415.414Z",
    transform: "translate(-21.58 -22.632)",
    fill: "#4a4e59"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXpLevel2);
export default __webpack_public_path__ + "static/media/xpLevel2.44286683dd6809c6ca8c188dbd3bd8e9.svg";
export { ForwardRef as ReactComponent };